import { Injector, NgModule, ViewContainerRef } from '@angular/core';

@NgModule({
  imports: [],
})
export abstract class WrapperModule {

  protected static loadedModule: any;

  private static injector: Injector;

  private static async loadConditionalModule(loaderFn: () => Promise<any>): Promise<any> {
    if (this.loadedModule)
      return this.loadedModule;

    try {
      const module = await loaderFn();
      return module;
    } catch (error) {
      console.error(`No se pudo cargar el módulo: `, error);
      return null;
    }
  }

  private static async initComponentInstance(loaderFn: () => Promise<any>, injector: Injector): Promise<void> {
    injector = injector ?? this.injector;
    if (!injector)
      throw new Error('WrapperModule cannot be initialized. Missing required parameter: Injector.');
    
    this.injector = injector;

    this.loadedModule = await this.loadConditionalModule(loaderFn);
  }

  protected static async getComponentInstance(loaderFn: () => Promise<any>, componentName: string, containerRef: ViewContainerRef, injector?: Injector): Promise<any> {
    await this.initComponentInstance(loaderFn, injector);

    const component = this.loadedModule?.[componentName];
    if (component) {
      containerRef.clear();
      const componentRef = containerRef.createComponent(component, {
        injector: this.injector
      });

      return componentRef.instance;
    }

    return null;
  }

  private static async initService(loaderFn: () => Promise<any>, expectedProps: any[], ...args: any[]): Promise<void> {
    expectedProps.forEach((propName, index) => {
      const arg = args[index];
      if (arg) {
        (this as any)[propName] = arg;
      } else if (!(this as any)[propName]) {
        throw new Error(`WrapperModule cannot be initialized. Missing required parameter: ${propName}.`);
      }
    });

    this.loadedModule = await this.loadConditionalModule(loaderFn);
  }

  protected static async getService(loaderFn: () => Promise<any>, serviceName: string, expectedProps: any[], ...args: any[]): Promise<any> {
    await this.initService(loaderFn, expectedProps, ...args);
    const serviceClass = this.loadedModule?.[serviceName];
    return serviceClass?.getInstance(...args) ?? null;
  }

}
